module.exports = __webpack_public_path__ + "img/phone-top.756232af.png";